import PersonType from '../enums/PersonType';

export const MASK_CPF = '000.000.000-00';
export const MASK_CNPJ = '00.000.000/0000-00';

export function getIdentiferMask(type: PersonType) {
  switch (type) {
    case PersonType.Natural:
      return MASK_CPF;
    case PersonType.Juridical:
      return MASK_CNPJ;
    default:
      return '';
  }
}

export function toIdentifierMask(value: string, type: PersonType) {
  switch (type) {
    case PersonType.Natural:
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    case PersonType.Juridical:
      return value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
      );
    default:
      return value;
  }
}

export const removeMask = (value: string) => value.replace(/[^0-9]/g, '');
